const CryptoJS = require('crypto-js');
const ENCRYPTION_KEY = 'u8x/A?D(G+KbPeSh';

export const encryptString = text => {
  return CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
};
export const decryptString = text => {
  let bytes = CryptoJS.AES.decrypt(text, ENCRYPTION_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

